import axios from 'axios';
import useGetMsalAccessToken from '../features/users/services/useGetMsalAccessToken';
import { useEffect } from 'react';

const headers = {
  Accept: 'application/json',
};

const nestClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/`,
  headers,
});

/**
 * Get a new instance of Axios for calls to the NestJS API.
 */
const useNestClient = () => {
  const { getAccessToken } = useGetMsalAccessToken();

  useEffect(() => {
    const reqInterceptor = nestClient.interceptors.request.use(async (config) => {
      const accessToken = await getAccessToken();
      config.headers.Authorization = `Bearer ${accessToken}`;

      return config;
    });

    // Cleanup function
    return () => {
      nestClient.interceptors.request.eject(reqInterceptor);
    };
  }, [getAccessToken]);
  return { nestClient };
};

export default useNestClient;
